module.exports = __webpack_public_path__ + "img/icon_new.0b607d21.png";